const TRX = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="10" cy="10" r="10" fill="#EB322A" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.06295 3.97934C4.15281 3.86729 4.29585 3.81203 4.4377 3.83454L14.6022 5.44796C14.6889 5.46171 14.7686 5.50355 14.8291 5.56704L17.2862 8.14497C17.336 8.19595 17.3727 8.26062 17.3897 8.33406C17.4083 8.41469 17.4018 8.50015 17.3695 8.57788C17.3562 8.60992 17.3385 8.64065 17.3164 8.66919C17.3141 8.67223 17.3117 8.67524 17.3092 8.67821L9.92892 17.7524C9.83929 17.8626 9.69793 17.917 9.55754 17.8953C9.41715 17.8736 9.2988 17.7791 9.24659 17.647L4.00298 4.37659C3.9502 4.24301 3.97309 4.09139 4.06295 3.97934ZM16.1735 8.13709L14.5576 6.44169L11.9697 8.72993L16.1735 8.13709ZM13.7166 6.1174L5.74939 4.85276L10.7171 8.7696L13.7166 6.1174ZM11.0602 9.66611L16.0465 8.96291L10.2303 16.114L11.0602 9.66611ZM9.44268 15.9663L5.32014 5.53308L10.282 9.44532L9.44268 15.9663Z"
      fill="white"
    />
  </svg>
);
export default TRX;
